import { render } from "./BtnLogin.vue?vue&type=template&id=9ddde134&scoped=true"
import script from "./BtnLogin.vue?vue&type=script&lang=js"
export * from "./BtnLogin.vue?vue&type=script&lang=js"

import "./BtnLogin.vue?vue&type=style&index=0&id=9ddde134&lang=scss&scoped=true"

import exportComponent from "H:\\git\\Net_Web_LandingVue\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ddde134"]])

export default __exports__